import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { MetaTags } from '@unistocks/features/navigation/meta-tags';
import { LineChart, PieChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  MarkLineComponent,
  MarkPointComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PropsWithChildren } from 'react';
import { SharedProvider } from './shared';

// eCharts language imports
import 'echarts/i18n/langSV';

// Register required ECharts components (tree-shaking)
echarts.use([
  CanvasRenderer,
  PieChart,
  LineChart,
  LegendComponent,
  TooltipComponent,
  GridComponent,
  MarkPointComponent,
  MarkLineComponent
]);

export function AppProvider({ children }: PropsWithChildren) {
  return (
    <SharedProvider>
      {children}
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
      <MetaTags />
    </SharedProvider>
  );
}
